export const selectEntitiesData = state => state.entities
